import { inject } from 'aurelia-framework';
import { ImportService } from 'pages/utilities/imports/service';
import { ProjectService } from 'pages/quote-setup/projects/service';
import { PlantService } from 'pages/quote-setup/plants/service';
import { CustomerService } from 'pages/quote-setup/customers/service';
import { PurchasePartTypeService } from 'pages/system-fields/purchase-part-types/service';
import toastr from 'toastr';

@inject(ImportService, ProjectService, PlantService, CustomerService, PurchasePartTypeService)
export class SGAProfitFreeze {
    constructor(importService, projectService, plantService, customerService, purchasePartTypeService) {
        this.importService = importService;
        this.projectService = projectService;
        this.plantService = plantService;
        this.customerService = customerService;
        this.purchasePartTypeService = purchasePartTypeService;

        this.filter = {};

        this.columns = [
            { dataField: 'parentPartNumber', caption: 'Parent Part' },
            { dataField: 'partNumber', caption: 'Part' },
            { dataField: 'plantName', caption: 'Plant' },
            { dataField: 'projectNumber', caption: 'Project' },
            { dataField: 'salesPrice', caption: 'Price' },
            { dataField: 'sga', caption: 'SGA' },
            { dataField: 'profit' },
        ];

        this.newData = [];
        this.existingData = [];
    }

    async search () {
        this.isSearching = true;
        this.data = await this.importService.searchSGAProfitFreeze(this.filter);
        this.newData = this.data.filter(x => !x.exists);
        this.existingData = this.data.filter(x => x.exists);
        this.newGrid.refresh();
        this.existingGrid.refresh();
        this.isSearching = false;
    }

    async update() {
        this.isUpdating = true;
        const selectedNew = this.newGrid.getSelectedRows();
        const selectedExisting = this.existingGrid.getSelectedRows();
        const ids = [...selectedNew.map(x => x.quoteStructureId), ...selectedExisting.map(x => x.quoteStructureId)]
        await this.importService.SGAProfitFreeze(ids);
        toastr.success('SGA and Profit Freeze ran successfully');
        this.data = null;
        this.isUpdating = false;
    }
}